import { SortDescriptor } from '@progress/kendo-data-query/dist/npm/sort-descriptor';
import {
  Grid,
  GridColumn,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuProps,
  GridCustomFilterCellProps,
  GridDataStateChangeEvent,
  GridFilterChangeEvent,
  GridFilterOperators,
  GridProps
} from '@progress/kendo-react-grid';
import React from 'react';

interface IKendoReactGridProps extends GridProps {
  id: string;
  dataState?: any;
}

/// A wrapper around KendoReact Grid when doing server-side operations (paging, sorting, filtering).
const KendoReactServerGrid = (props: IKendoReactGridProps) => {
  return (
    props && (
      <div className="kendo-react-grid">
        <link
          href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
          rel="stylesheet"
          type="text/css"
        />
        <Grid
          autoProcessData={props.autoProcessData}
          data={props.data}
          onDataStateChange={props.onDataStateChange}
          dataItemKey={props.dataItemKey}
          defaultSort={props.defaultSort}
          defaultTake={props.defaultTake}
          filterable={props.filterable}
          id={props.id}
          pageable={props.pageable}
          sortable={props.sortable}
          resizable={props.resizable}
          total={props.total}
          pageSize={props.pageSize}
          {...props.dataState}
        >
          {props.children}
        </Grid>
      </div>
    )
  );
};

export default KendoReactServerGrid;

export {
  GridColumn,
  GridColumnMenuProps,
  GridColumnMenuCheckboxFilter,
  GridCustomFilterCellProps,
  GridFilterChangeEvent,
  GridFilterOperators,
  GridDataStateChangeEvent,
  SortDescriptor
};
